import {
	START_DOWNLOAD,
	END_DOWNLOAD,
	DOWNLOAD_PROGRESS,
	START_BULK_DOWNLOAD,
	END_BULK_DOWNLOAD,
	DOWNLOAD_BULK_PROGRESS,
	SET_SELECTED_DOCUMENT_IDS,
	RESET_SELECTED_DOCUMENT_IDS,
} from "../types"

const initialState = {
	documents: {},
	isDownloading: false,
	bulk_download: {
		downloading: false,
		percentage: 0,
	},
	selectedDocumentIds: {},
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case START_DOWNLOAD:
			let auxDownloads = { ...state.documents }
			auxDownloads[action.payload] = { downloading: true, percentage: 0 }
			return {
				...state,
				documents: auxDownloads,
				isDownloading: true,
			}
		case END_DOWNLOAD:
			let auxDownloadsStop = { ...state.documents }
			auxDownloadsStop[action.payload] = { downloading: false, percentage: 0 }

			return {
				...state,
				documents: auxDownloadsStop,
				isDownloading: false,
			}
		case DOWNLOAD_PROGRESS:
			let auxDownloadProgress = state.documents
			auxDownloadProgress[action.payload.id].percentage = action.payload.percentage
			return {
				...state,
				documents: auxDownloadProgress,
			}
		case START_BULK_DOWNLOAD:
			let auxBulkDownloads = { ...state.bulk_download }
			auxBulkDownloads = { downloading: true, percentage: 0 }
			return {
				...state,
				bulk_download: auxBulkDownloads,
				isDownloading: true,
			}
		case END_BULK_DOWNLOAD:
			let auxBulkDownloadsStop = { ...state.bulk_download }
			auxBulkDownloadsStop = { downloading: false, percentage: 0 }

			return {
				...state,
				bulk_download: auxBulkDownloadsStop,
				isDownloading: false,
			}
		case DOWNLOAD_BULK_PROGRESS:
			let auxBulkDownloadProgress = state.bulk_download
			auxDownloadProgress[action.payload.id].percentage = action.payload.percentage
			return {
				...state,
				documents: auxBulkDownloadProgress,
			}

		case SET_SELECTED_DOCUMENT_IDS:
			return {
				...state,
				selectedDocumentIds: action?.payload,
			}
		case RESET_SELECTED_DOCUMENT_IDS:
			return {
				...state,
				selectedDocumentIds: [],
			}

		default:
			return state
	}
}
